const OpcionesValidacionInicial = (props) => {
  const isPCA = props.form.initialValidationOption.value === 'Asignar a Profesional Centro de Apoyo';

  return (
    <div>
      <form className="form-horizontal">
        <div className="form-group">
          <label className="control-label col-sm-3">
            {i18next.t('resultadovalidacion')}
          </label>
          <div className="col-sm-9">
            <DropdownButton title={props.form.initialValidationOption.value || 'Seleccionar'} id="initialValidationOption" className="dropdown-custom" bsStyle="large" onSelect={(value) => props.handleSwitchSelect(value, 'initialValidationOption')}>
              {props.initialValidationOptionsList.map((initialValidationOption) => {
                return <MenuItem eventKey={initialValidationOption.text} className={props.form.initialValidationOption.value === initialValidationOption.text ? 'active' : ''}>{initialValidationOption.text}</MenuItem>
              })}
            </DropdownButton>
          </div>
        </div>
        {(isPCA) && <div className="form-group">
          <label className="control-label col-sm-3">
            {i18next.t('complejidad')}
          </label>
          <div className="col-sm-9">
            <DropdownButton title={props.form.complexity.value || 'Seleccionar'} id="complexity" className="dropdown-custom" bsStyle="large" onSelect={(value) => props.handleSwitchSelect(value, 'complexity')}>
              {props.complexityList.map((complexity) => {
                return <MenuItem eventKey={complexity.text} className={props.form.complexity.value === complexity.text ? 'active' : ''}>{complexity.text}</MenuItem>
              })}
            </DropdownButton>
          </div>
        </div>}
        {(isPCA) && <div className="form-group">
          <label className="control-label col-sm-3">
            {i18next.t('profCentroDeApoyo')}
          </label>
          <div className="col-sm-9">
            <DropdownButton title={props.form.supportProffesional.value || 'Seleccionar'} id="supportProffesional" className="dropdown-custom" bsStyle="large" onSelect={(value) => props.handleSwitchSelect(value, 'supportProffesional')}>
              {props.supportProffesionalsList.map((supportProffesional) => {
                return <MenuItem eventKey={supportProffesional.name} className={props.form.supportProffesional.value === supportProffesional.name ? 'active' : ''}>{supportProffesional.name}</MenuItem>
              })}
            </DropdownButton>
          </div>
        </div>}
        <div className="form-group">
          <label className="control-label col-sm-3">
            {i18next.t('observaciones')}
          </label>
          <div className="col-sm-9">
            <DropdownButton title={props.form.observaciones.value || 'Seleccionar'} id="observaciones" className="dropdown-custom" bsStyle="large" onSelect={(value) => props.handleSwitchSelect(value, 'observaciones')}>
              {props.observacionesList.map((observacion) => {
                return <MenuItem eventKey={observacion.text} className={props.form.observaciones.value === observacion.name ? 'active' : ''}>{observacion.text}</MenuItem>
              })}
            </DropdownButton>
          </div>
        </div>
        <div className="form-group">
          <label className="control-label col-sm-3">
            {i18next.t('observacionesAsegurabilidad')}
          </label>
          <div className="col-sm-9">
            <textarea value={props.form.viabilityObservaciones.value} id="viabilityObservaciones" onChange={(e) => props.handleTextInputChange(e, 'viabilityObservaciones')} rows="5" className="observaciones-area"></textarea>
          </div>
        </div>
      </form>
    </div>
  )
}

const Popover = ReactBootstrap.Popover;
const MenuItem = ReactBootstrap.MenuItem;
const DropdownButton = ReactBootstrap.DropdownButton;
const Button = ReactBootstrap.Button;
const OverlayTrigger = ReactBootstrap.OverlayTrigger;

export default OpcionesValidacionInicial;


// WEBPACK FOOTER //
// ./cicloVentaAfiliacion/informacionDelCasoAsegurabilidad/src/components/opcionesValidacionInicial.js